import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_106ca599";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_106ca599" };
/** script content **/
require("./popup.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex106ca599%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fpopup%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_106ca599"],
    ctorType: "component",
    outputPath: "components/index106ca599/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'mpx-rich-text': getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-rich-text?isComponent"), { __mpxBuiltIn: true }) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
